module.exports = __webpack_public_path__ + "img/icon-ticket-reward.ce5f7191.svg";